export const LOGIN_TYPE = {
  EMAIL: 'EMAIL',
  PHONE: 'PHONE',
  FACEBOOK: 'FACEBOOK',
  WECHAT: 'WECHAT',
};

export const CODE_TYPE = {
  BIND: 'BIND',
  LOGIN: 'LOGIN',
  SIGNUP: 'SIGNUP',
  AUTH: 'AUTH',
};

export const COMPANY_TYPE = {
  REAL_ESTATE_AGENCY: 'Real Estate Agency',
  PROPERTY_MANAGEMENT_COMPANY: 'Property Management Company',
  PRIVATE_MANAGEMENT: 'Private Management',
  UNIVERSITY_OWNED_OR_MANAGED: 'University Owned/Managed',
  HMO: 'HMO (House of Multiple Occupants)',
  OTHER: 'Other',
};
